<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card class="p-2">
    <nb-card-body>
      <div class="text mb-2">
        <span class="py-2" style="font-weight: bold"> You will receive the export on your email </span>
      </div>
      <div class="btns py-2 tw-flex tw-justify-between">
        <button class="float-left" nbButton status="basic" size="medium" (click)="ref.close()">CANCEL</button>
        <button class="float-right" nbButton status="primary" size="medium" (click)="export(); ref.close()">Export</button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>

<ng-template #importRef></ng-template>

<ng-template #benchmarkConnect let-data let-ref="dialogRef">
  <nb-card class="benchmarkConnect">
    <nb-card-body>
      <div *ngIf="showSuccess">
        <div class="title">We started pushing your export to Benchmark email to the list,</div>
        <div class="wrosname">MICEtribe-{{ auth.currentWorkspace.name }}</div>
        <div class="recieve">You will receive a confirmation email when the process is completed</div>
        <div class="done-btn">
          <button fullWidth nbButton status="primary" size="medium" (click)="ref.close()" style="border: none">DONE</button>
        </div>
      </div>
      <div *ngIf="!showSuccess">
        <div class="row mblogo" style="text-align: center">
          <svg width="165" height="45" viewBox="0 0 165 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: auto">
            <path
              d="M62.5075 28.9459H57.69V26.027H61.3031C61.4236 26.027 61.544 25.9054 61.544 25.7838V24.081C61.544 23.9594 61.4236 23.8378 61.3031 23.8378H57.69V20.9189H62.3871C62.5075 20.9189 62.628 20.7973 62.628 20.6756V19.0946C62.628 18.9729 62.5075 18.8513 62.3871 18.8513H55.5221C55.4017 18.8513 55.2812 18.9729 55.2812 19.0946V30.7702C55.2812 30.8919 55.4017 31.0135 55.5221 31.0135H62.5075C62.628 31.0135 62.7484 30.8919 62.7484 30.7702V29.0675C62.7484 28.9459 62.628 28.9459 62.5075 28.9459Z"
              fill="#1D202D"
            />
            <path
              d="M77.2001 18.9729H75.1527C75.0322 18.9729 74.9118 19.0945 74.9118 19.2161V26.6351L69.3717 19.0945L69.2512 18.9729H67.2038C67.0833 18.9729 66.9629 19.0945 66.9629 19.2161V30.8918C66.9629 31.0134 67.0833 31.1351 67.2038 31.1351H69.2512C69.3717 31.1351 69.4921 31.0134 69.4921 30.8918V23.4729L75.0322 31.0134L75.1527 31.1351H77.2001C77.3206 31.1351 77.441 31.0134 77.441 30.8918V19.2161C77.441 18.9729 77.3206 18.9729 77.2001 18.9729Z"
              fill="#1D202D"
            />
            <path
              d="M90.4495 26.392C90.3291 26.392 90.2086 26.392 90.2086 26.5136C89.486 28.0947 88.2816 28.8244 86.7159 28.8244C84.6685 28.8244 83.2232 27.2433 83.2232 24.6893C83.2232 22.0136 84.9093 20.6758 86.9568 20.6758C87.9203 20.6758 89.1247 21.0406 89.9677 22.1352C90.0882 22.2568 90.2086 22.2568 90.2086 22.1352L91.6539 20.7974C91.7743 20.6758 91.7743 20.5541 91.6539 20.5541C90.4495 19.0947 88.6429 18.4866 87.0772 18.4866C83.9458 18.4866 80.8145 20.6758 80.8145 24.9325C80.8145 28.8244 83.5845 31.2568 86.7159 31.2568C89.0042 31.2568 91.1721 30.0406 92.1356 27.7298C92.1356 27.6082 92.1356 27.4866 92.0152 27.4866L90.4495 26.392Z"
              fill="#1D202D"
            />
            <path
              d="M105.262 18.9729H103.215C103.094 18.9729 102.974 19.0945 102.974 19.2161V23.9594H97.7948V19.2161C97.7948 19.0945 97.6744 18.9729 97.5539 18.9729H95.5065C95.3861 18.9729 95.2656 19.0945 95.2656 19.2161V30.8918C95.2656 31.0134 95.3861 31.1351 95.5065 31.1351H97.5539C97.6744 31.1351 97.7948 31.0134 97.7948 30.8918V26.1486H102.974V30.8918C102.974 31.0134 103.094 31.1351 103.215 31.1351H105.262C105.382 31.1351 105.503 31.0134 105.503 30.8918V19.2161C105.382 18.9729 105.382 18.9729 105.262 18.9729Z"
              fill="#1D202D"
            />
            <path
              d="M122.005 18.9729H119.716C119.596 18.9729 119.596 18.9729 119.596 19.0946L116.103 25.4189L112.611 18.9729C112.611 18.8513 112.49 18.8513 112.49 18.8513H110.202C110.081 18.8513 109.961 18.9729 109.961 19.0946V30.7702C109.961 30.8919 110.081 31.0135 110.202 31.0135H112.008C112.129 31.0135 112.249 30.8919 112.249 30.7702V23.3513L115.019 28.3378C115.019 28.4594 115.14 28.4594 115.14 28.4594H116.946C117.067 28.4594 117.067 28.4594 117.067 28.3378L119.837 23.3513V30.7702C119.837 30.8919 119.957 31.0135 120.078 31.0135H122.125C122.246 31.0135 122.366 30.8919 122.366 30.7702V19.0946C122.246 18.9729 122.125 18.9729 122.005 18.9729Z"
              fill="#1D202D"
            />
            <path
              d="M132.361 18.9729H130.314C130.193 18.9729 130.193 18.9729 130.073 19.0945L125.496 30.7702C125.496 30.8918 125.496 31.0134 125.737 31.0134H127.905C128.025 31.0134 128.025 31.0134 128.146 30.8918L129.109 28.3378H133.565L134.529 30.8918C134.529 31.0134 134.649 31.0134 134.77 31.0134H136.938C137.058 31.0134 137.179 30.8918 137.179 30.7702L132.722 19.0945C132.482 18.9729 132.482 18.9729 132.361 18.9729ZM129.952 26.027L131.277 22.3783L132.602 26.027H129.952Z"
              fill="#1D202D"
            />
            <path
              d="M146.813 25.6621C148.379 24.9324 148.981 23.5946 148.981 22.3783C148.981 20.4324 147.656 18.8513 145.247 18.8513H140.671C140.55 18.8513 140.43 18.9729 140.43 19.0946V30.7702C140.43 30.8919 140.55 31.0135 140.671 31.0135H142.718C142.838 31.0135 142.959 30.8919 142.959 30.7702V26.1486H144.284L147.054 30.8919C147.054 31.0135 147.174 31.0135 147.174 31.0135H149.583C149.703 31.0135 149.824 30.8919 149.703 30.7702L146.813 25.6621ZM144.765 24.081H142.718V20.9189H144.765C145.729 20.9189 146.452 21.6486 146.452 22.5C146.572 23.3513 145.849 24.081 144.765 24.081Z"
              fill="#1D202D"
            />
            <path
              d="M163.435 30.527L158.015 24.5676L163.074 19.0946C163.194 18.973 163.074 18.7297 162.953 18.7297H160.424C160.424 18.7297 160.304 18.7297 160.304 18.8514L155.848 23.8378V18.973C155.848 18.8514 155.727 18.7297 155.607 18.7297H153.559C153.439 18.7297 153.318 18.8514 153.318 18.973V30.6487C153.318 30.7703 153.439 30.8919 153.559 30.8919H155.607C155.727 30.8919 155.848 30.7703 155.848 30.6487V25.6622L160.424 30.6487L160.545 30.7703H163.315C163.556 30.8919 163.556 30.7703 163.435 30.527Z"
              fill="#1D202D"
            />
            <path
              d="M48.8982 24.4459C49.9821 24.081 50.8252 22.9865 50.8252 21.7702C50.8252 20.1892 49.6208 18.8513 47.2121 18.8513H42.9967C42.8763 18.8513 42.7559 18.9729 42.7559 19.0946V30.7702C42.7559 30.8919 42.8763 31.0135 42.9967 31.0135H47.3325C49.9821 31.0135 51.3069 29.0675 51.3069 27.3648C51.3069 25.7838 50.1026 24.6892 48.8982 24.4459ZM45.0442 20.9189H46.9712C47.6938 20.9189 48.4164 21.2838 48.4164 22.2567C48.4164 23.1081 47.6938 23.7162 46.8507 23.7162H45.0442V20.9189ZM46.9712 28.9459H45.0442V25.7838H47.0916C48.0551 25.7838 49.0186 26.2702 49.0186 27.2432C48.7778 28.2162 47.9347 28.9459 46.9712 28.9459Z"
              fill="#1D202D"
            />
            <path
              d="M22.1597 35.5135L16.2583 41.5946C15.6561 42.2027 15.6561 42.9325 16.2583 43.5406C16.4992 43.7838 16.8605 43.9054 17.1013 43.9054C17.3422 43.9054 17.824 43.7838 17.9444 43.5406L23.9663 37.4595C24.5685 36.8514 24.5685 36.1217 23.9663 35.5135C23.4846 35.0271 22.7619 35.0271 22.1597 35.5135Z"
              fill="#1D202D"
            />
            <path
              d="M3.73332 28.2162C3.73332 28.0946 3.9742 27.6081 4.57639 26.6351C5.53989 25.1757 7.10559 23.3514 9.15303 21.4054L10.1165 20.4324C10.5983 19.946 11.2005 19.8243 11.8027 20.0676L11.6822 19.946C11.3209 19.5811 11.3209 19.2162 11.6822 18.8514L12.0435 18.4865C12.6457 17.8784 12.6457 17.1487 12.0435 16.5406C11.4414 15.9324 10.7187 15.9324 10.1165 16.5406L7.22602 19.5811C5.17858 21.7703 3.49245 23.8379 2.28807 25.5406C1.445 26.7568 1.32456 27.4865 1.20413 27.7297C1.08369 28.4595 1.56544 29.1892 2.16763 29.3108H2.52894C3.13113 29.1892 3.61288 28.946 3.73332 28.2162Z"
              fill="#1D202D"
            />
            <path
              d="M31.1944 1.58116L12.5265 20.4325C13.2492 21.1622 13.2492 22.1352 12.5265 22.6217L12.0448 23.1082L9.03383 26.1487C3.61412 31.6217 3.01193 34.0541 2.89149 34.5406C2.77105 35.2704 3.2528 36.0001 3.97543 36.1217H4.21631C4.93894 36.1217 5.30025 35.6352 5.54113 35.1487C5.54113 35.0271 5.782 34.5406 6.38419 33.446C7.10682 32.3514 8.43164 30.5271 10.9608 27.9731L11.9243 27.0001C12.4061 26.5136 13.0083 26.392 13.6105 26.6352L13.49 26.5136C13.1287 26.1487 13.1287 25.7839 13.49 25.419L13.8513 25.0541C14.4535 24.446 14.4535 23.7163 13.8513 23.1082L13.6105 22.8649L33.001 3.40549C33.6032 2.79738 33.6032 2.06765 33.001 1.45954C32.5192 1.09468 31.6762 1.09468 31.1944 1.58116Z"
              fill="#1D202D"
            />
            <path
              d="M28.1833 12.8918L14.333 26.9999C15.0556 27.7296 15.0556 28.7026 14.333 29.1891L13.8512 29.6756L10.9607 32.5945C8.67239 34.9053 6.86582 37.3377 5.90232 39.5269C5.17969 41.2296 5.17969 42.2026 5.17969 42.4458C5.17969 43.1756 5.78188 43.7837 6.5045 43.7837C7.22713 43.7837 7.82932 43.1756 7.82932 42.4458C7.82932 42.4458 7.82932 41.7161 8.43151 40.4999C9.51545 38.1891 11.4425 35.8783 13.0082 34.2972L13.9717 33.3242C14.4534 32.8377 15.0556 32.7161 15.6578 32.9594L15.5374 32.8377C15.176 32.4729 15.176 32.108 15.5374 31.7431L15.8987 31.3783C16.5009 30.7702 16.5009 30.0404 15.8987 29.4323L15.6578 29.1891L30.2308 14.5945C30.833 13.9864 30.833 13.2567 30.2308 12.6485C29.5082 12.4053 28.7855 12.4053 28.1833 12.8918Z"
              fill="#1D202D"
            />
            <path
              d="M25.1715 24.3244L16.0182 33.5676C16.7408 34.2973 16.7408 35.2703 16.0182 35.7568L14.6934 37.0946C15.2955 37.4595 15.8977 37.4595 16.3795 36.8514L26.978 26.1487C27.5802 25.5406 27.5802 24.8108 26.978 24.2027C26.4963 23.7163 25.7737 23.7163 25.1715 24.3244Z"
              fill="#1D202D"
            />
          </svg>
        </div>
        <div class="row">
          <span> Connect to your Benchmark account </span>
        </div>
        <div class="row error">
          <div class="col-md-12 errormsg" *ngIf="show">incorrect email or password</div>
        </div>
        <div class="text mb-2">
          <div class="row">
            <div class="col-md-3"><label>Email</label></div>
            <div class="col-md-9">
              <input type="email" [(ngModel)]="benchmarkEmail" placeholder="Benchmark Email" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <label>Password</label>
            </div>
            <div class="col-md-9">
              <input type="password" [(ngModel)]="benchmarkPwd" placeholder="Benchmark password" />
            </div>
          </div>
        </div>
        <div class="btns py-2">
          <button class="col-md-12" nbButton status="primary" size="medium" (click)="connectBenchmark()" style="border: none">CONNECT & EXPORT</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>

<mat-toolbar class="db-toolbar d-flex align-items-center tw-relative">
  <!-- Search pill always visible; bulk actions will push it -->
  <div class="toolbar-search flex-grow-1 tw-relative">
    <div class="search-pill" [class.has-filters]="activeFilters.length > 0">
      <mat-icon class="prefix">search</mat-icon>

      <!-- Filter chips inside search bar -->
      <div class="filter-chips" *ngIf="activeFilters.length > 0">
        <span class="filter-chip" [class.inverted]="filter.inverted" *ngFor="let filter of activeFilters">
          <span class="chip-prefix" *ngIf="filter.inverted">NOT</span>
          <span class="chip-label">{{ filter.label }}:</span>
          <span class="chip-value">{{ filter.values.length > 1 ? filter.values.length + ' selected' : filter.values[0] }}</span>
          <button class="chip-remove" (click)="removeFilter(filter.field); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>

      <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearchTermChangedEvent($event)" placeholder="Search registrations..." />

      <!-- AI Search Link - Only visible when beta feature is enabled -->
      <button class="ai-search-link" *ngIf="isAISearchEnabled" (click)="openAISearch()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="gradient-text">Search with AI</span>
      </button>

      <button class="clear-btn" *ngIf="searchTerm || activeFilters.length > 0" (click)="clearAllFilters()" ngxTippy="Clear all">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Right: Icon menus -->
  <div class="toolbar-actions right">
    <!-- Saved filters dropdown -->
    <app-saved-filters-dropdown
      #savedFiltersDropdownRef
      [savedFilters]="savedFilters"
      [hasActiveFilters]="hasActiveFilters"
      (filterSelected)="onLoadFilter($event)"
      (filterDeleted)="onDeleteFilter($event)"
      (saveRequested)="onSaveFilter($event)"
    ></app-saved-filters-dropdown>

    <!-- Bulk actions as compact icons -->
    <div class="bulk-icon-actions" *ngIf="selectionExists && workspaceRole.canAccessBulkActions()">
      <span class="selection-count" [ngxTippy]="getSelectionTooltip()">({{ getSelectionDisplay() }})</span>
      <button mat-icon-button class="icon-btn approve" ngxTippy="Approve selected" (click)="openBulkAction(bulkApprove)">
        <mat-icon>check_circle</mat-icon>
      </button>
      <button mat-icon-button class="icon-btn decline" ngxTippy="Decline selected" (click)="openBulkAction(bulkDisapprove)">
        <mat-icon>cancel</mat-icon>
      </button>
      <button mat-icon-button class="icon-btn revision" ngxTippy="Request revision" (click)="openBulkRevisionRequestModal()">
        <mat-icon>edit_note</mat-icon>
      </button>
      <button mat-icon-button class="icon-btn delete" ngxTippy="Delete selected" (click)="openBulkAction(bulkDelete)">
        <mat-icon>delete</mat-icon>
      </button>
      <span [ngxTippy]="isEventStarted ? 'Mark unattended' : 'Event not started'" [ngClass]="!isEventStarted ? 'tw-cursor-not-allowed' : ''">
        <button mat-icon-button class="icon-btn unattended" [disabled]="!isEventStarted" [ngClass]="{ 'disabled-button': !isEventStarted }" (click)="openBulkAction(bulkUnattend)">
          <mat-icon>person_off</mat-icon>
        </button>
      </span>
      <span [ngxTippy]="isEventStarted ? 'Mark attended' : 'Event not started'" [ngClass]="!isEventStarted ? 'tw-cursor-not-allowed' : ''">
        <button mat-icon-button class="icon-btn attended" [disabled]="!isEventStarted" [ngClass]="{ 'disabled-button': !isEventStarted }" (click)="openBulkAction(bulkAttend)">
          <mat-icon>badge</mat-icon>
        </button>
      </span>
      <button mat-icon-button class="icon-btn resend" ngxTippy="Resend confirmation" (click)="openResendConfirmationFlow()">
        <mat-icon>sync</mat-icon>
      </button>
      <button mat-icon-button class="icon-btn invite" ngxTippy="Invite to event" (click)="openInvite()">
        <mat-icon>mail</mat-icon>
      </button>
      <button mat-icon-button class="icon-btn settle" ngxTippy="Settle selected" (click)="openSettle()">
        <mat-icon>lock</mat-icon>
      </button>
    </div>

    <button mat-icon-button class="icon-btn" ngxTippy="Invitation history" (click)="openInvitationHistoryDialog()">
      <mat-icon>history</mat-icon>
    </button>

    <!-- Auto refresh at the end -->
    <button mat-icon-button class="icon-btn" [class.active]="autoRefresh" ngxTippy="Auto refresh" (click)="toggleAutoRefresh(!autoRefresh)">
      <mat-icon>autorenew</mat-icon>
      <span class="badge-dot" *ngIf="autoRefresh"></span>
    </button>
    <ng-container *ngFor="let options of visabilityOptions; let i = index">
      <ng-container *ngIf="i === registrationsDataSourceCollection.selectedIndex">
        <button mat-icon-button class="icon-btn" [matMenuTriggerFor]="contextMenu" ngxTippy="Columns">
          <mat-icon>view_column</mat-icon>
        </button>
        <mat-menu #contextMenu="matMenu">
          <ng-container *ngFor="let option of options; let j = index">
            <button mat-menu-item *ngIf="option.data.visable" (click)="toggleVisability($event, j)">
              <mat-checkbox [checked]="option.data.checked" color="primary">{{ option.title }}</mat-checkbox>
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </ng-container>

    <div ngxTippy="Status" style="display: inline-block">
      <button mat-icon-button class="icon-btn" [nbContextMenu]="statusOptions" nbContextMenuTag="filter-option">
        <mat-icon>tune</mat-icon>
      </button>
    </div>

    <div *ngIf="canImportOrExport" ngxTippy="{{ importExportLabel }}" style="display: inline-block">
      <button mat-icon-button class="icon-btn" [nbContextMenu]="importExportMenu" nbContextMenuTag="my-eports-menu">
        <mat-icon>import_export</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Bulk approve -->
<ng-template #bulkApprove let-ref="dialogRef" let-data>
  <nb-card>
    <nb-card-body>
      <div class="modal-message">
        Are you sure you want to approve
        <span class="font-weight-bold">{{ numberOfselected() }}</span> registrants?
      </div>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="primary" (click)="registrationsDataSourceCollection.approveSelections(); ref.close()">approve</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk approve -->

<!-- Bulk disapprove -->
<ng-template #bulkDisapprove let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="modal-message">
        Are you sure you want to disapprove
        <span class="font-weight-bold">{{ numberOfselected() }}</span> registrants?
      </div>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="danger" (click)="registrationsDataSourceCollection.disapproveSelections(); ref.close()">disapprove</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk disapprove -->

<!-- Bulk delete -->
<ng-template #bulkDelete let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <p>
        Please confirm that you want to delete
        <strong
          ><span class="font-weight-bold">{{ numberOfselected() }}</span></strong
        >
        users by typing the amount in the input field below
      </p>
      <p class="text-danger italic d-flex align-items-center"><mat-icon>warning</mat-icon> This action can't be undone!</p>
      <nb-form-field>
        <input [(ngModel)]="confirmationNumber" type="text" nbInput fullWidth shape="rectangle" [placeholder]="numberOfselected()" />
      </nb-form-field>
      <span class="text-danger" *ngIf="confirmationText">{{ confirmationText }}</span>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close(); confirmationNumber = ''; confirmationText = ''">cancel</button>
        <button nbButton status="danger" (click)="deleteSelections(ref)">delete</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk delete -->

<!-- Bulk attended -->
<ng-template #bulkAttend let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="modal-message">
        Are you sure you want to mark as attended
        <span class="font-weight-bold">{{ numberOfselected() }}</span> registrants?
        <div class="mt-2" *ngIf="getChildrenCount() > 0">
          <span class="text-secondary"
            >This includes {{ getParentCount() }} parent{{ getParentCount() !== 1 ? 's' : '' }} and {{ getChildrenCount() }} child{{ getChildrenCount() !== 1 ? 'ren' : '' }}.</span
          >
        </div>
        <div class="mt-2 text-secondary">Please note that only the approved registrations will be marked as attended.</div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="primary" (click)="registrationsDataSourceCollection.bulkAttendSelection(); ref.close()">Confirm</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk attended -->

<!-- Bulk unattended -->
<ng-template #bulkUnattend let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="modal-message">
        Are you sure you want to mark as unattended
        <span class="font-weight-bold">{{ numberOfselected() }}</span> registrants?
        <div class="mt-2" *ngIf="getChildrenCount() > 0">
          <span class="text-secondary"
            >This includes {{ getParentCount() }} parent{{ getParentCount() !== 1 ? 's' : '' }} and {{ getChildrenCount() }} child{{ getChildrenCount() !== 1 ? 'ren' : '' }}.</span
          >
        </div>
      </div>
      <p class="text-danger italic"><mat-icon>warning</mat-icon> This action can't be undone!</p>
    </nb-card-body>
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" (click)="ref.close()">cancel</button>
        <button nbButton status="danger" (click)="registrationsDataSourceCollection.bulkUnttendSelection(); ref.close()">Unattended</button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Bulk unattended -->

<!-- Settle to invite Modal -->
<modal
  [id]="settleToInviteModalId"
  [header]="'Send Invitations'"
  [closeButtonEnabled]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-[95vw] sm:tw-w-[480px]'"
  [heightClass]="'tw-h-fit'"
  [enableBackdropClose]="true"
  (onCloseModal)="closeSettleToInviteModal()"
>
  <div slot="body" class="tw-font-inter tw-text-base tw-text-gray-700">
    <p class="tw-m-0">
      You only have settled
      {{
        numberOfselected() - unsettledCount !== 1
          ? numberOfselected() - unsettledCount + ' entires'
          : ' 1 entry'
      }}
      out of {{ numberOfselected() !== 1 ? +numberOfselected() + ' entries' : ' 1 entry' }}. All unsettled entries will be skipped.
    </p>
  </div>
  <div slot="footer" class="tw-px-6 tw-pb-4 tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
    <button
      type="button"
      class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-900 hover:tw-bg-gray-50"
      (click)="openInvite(true)"
      *ngIf="numberOfselected() - unsettledCount > 0"
    >
      Proceed without settling ({{ numberOfselected() - unsettledCount }})
    </button>
    <button
      type="button"
      class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-600 tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700"
      (click)="openSettle(true)"
      [ngClass]="{ 'tw-w-full': numberOfselected() - unsettledCount === 0 }"
    >
      Settle all and proceed
    </button>
  </div>
</modal>
<!-- ./Settle to invite Modal -->

@if (showInviteModal && invitationInfo) {
<ngx-invitation
  [modalId]="inviteModalId"
  [invitationInfo]="invitationInfo"
  (closed)="onInviteModalClosed()"
></ngx-invitation>
}

<!-- Saved Filters Dropdown Panel - Rendered outside toolbar to avoid overflow clipping -->
<div
  class="saved-filters-dropdown-panel"
  *ngIf="savedFiltersDropdown?.isOpen"
  [style.top.px]="savedFiltersDropdown?.dropdownTop"
  [style.left.px]="savedFiltersDropdown?.dropdownLeft"
>
  <!-- Save mode -->
  <div class="save-mode" *ngIf="savedFiltersDropdown?.isSaveMode">
    <div class="save-header">
      <mat-icon>bookmark_add</mat-icon>
      <span>Save Current Filters</span>
    </div>
    <div class="save-input">
      <input type="text" nbInput fullWidth [(ngModel)]="savedFiltersDropdown.newFilterName" placeholder="Filter name..." (keyup.enter)="savedFiltersDropdown.saveFilter()" />
    </div>
    <div class="save-actions">
      <button nbButton size="small" status="basic" (click)="savedFiltersDropdown.cancelSave()">Cancel</button>
      <button nbButton size="small" status="primary" [disabled]="!savedFiltersDropdown.newFilterName?.trim()" (click)="savedFiltersDropdown.saveFilter()">Save</button>
    </div>
  </div>

  <!-- List mode -->
  <ng-container *ngIf="!savedFiltersDropdown?.isSaveMode">
    <div class="dropdown-header">
      <span>Saved Filters</span>
      <button *ngIf="hasActiveFilters" class="add-btn" (click)="savedFiltersDropdown.showSaveMode()" ngxTippy="Save current filters">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div class="filters-list" *ngIf="savedFilters.length > 0">
      <div class="filter-item" *ngFor="let filter of savedFilters" (click)="savedFiltersDropdown.selectFilter(filter)">
        <div class="filter-info">
          <div class="filter-name">{{ filter.name }}</div>
          <div class="filter-meta">
            <span class="filter-summary">{{ savedFiltersDropdown.getFilterSummary(filter) }}</span>
            <span class="filter-creator">by {{ filter.created_by.name }}</span>
          </div>
        </div>
        <button class="delete-btn" (click)="savedFiltersDropdown.deleteFilter($event, filter.id)" ngxTippy="Delete filter">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>

    <div class="empty-state" *ngIf="savedFilters.length === 0">
      <mat-icon>filter_list_off</mat-icon>
      <p>No saved filters yet</p>
      <p class="hint" *ngIf="hasActiveFilters">Click the + button to save your current filters</p>
      <p class="hint" *ngIf="!hasActiveFilters">Apply some filters first, then save them here</p>
    </div>
  </ng-container>
</div>

<!-- Backdrop for saved filters dropdown -->
<div class="saved-filters-backdrop" *ngIf="savedFiltersDropdown?.isOpen" (click)="savedFiltersDropdown.close()"></div>
